import React from 'react';
import { Divider, Dropdown, Pagination, Space } from 'antd';
import ArrowDown from '../../assets/images/ArrowDown.png';
import { useTranslation } from 'react-i18next';

type Props = {
  menuProps: any;
  onChange: any;
  current: any;
  dataLength: any;
  handleLength: any;
  total: any;
};

const Paginations = (props: Props) => {
  let { menuProps, onChange, current, dataLength, total } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'branch',
  });
  return (
    <div className="footer">
      <div className="dropdownContainer">
        <div className="showText font">{t('showing')}</div>
        <Dropdown menu={menuProps} trigger={['click']} placement="top">
          <Space>
            <div
              className={`dropdown ${dataLength > 9 ? 'dropdownValue' : ''}`}
            >
              <div className="count font">{dataLength}</div>
              <Divider type="vertical" />
              <img src={ArrowDown} alt="" className="dropdownIcon" />
            </div>
          </Space>
        </Dropdown>
        <div className="showText font">{t('of')}</div>
        <div className="total font">{total}</div>
      </div>

      <Pagination
        current={current}
        onChange={onChange}
        total={total}
        pageSize={dataLength}
        showSizeChanger={false}
      />
    </div>
  );
};

export default Paginations;
